export function isValidId(id: unknown): boolean {
  if (typeof id !== 'number' && typeof id !== 'string') return false

  let num: bigint
  try {
    if (typeof id === 'bigint') num = id
    else num = BigInt(id)
  } catch {
    return false // Not a bigint and cannot be converted
  }
  return num > 10n ** 18n // Should be larger than 1e18
}
